import CommentIcon from "@mui/icons-material/Comment";
import SendIcon from "@mui/icons-material/Send";
import ShareIcon from "@mui/icons-material/Share";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Avatar } from "@mui/material";
import React from "react";
// import moment from "moment";
import InputOption from "./InputOption";
import profile from '../../assets/image/finewords.jpg'

// interface Props {
//   post: {};
//   ref: any;
//   name: any;
//   description: any;
//   photoUrl: any;
// }

const Post = () => {


  return (
    <div style={{ marginBottom: "40px" }}>
      <div className="post" >
        <div className="post_header">
          <Avatar src={profile}></Avatar>
          <div className="post_info">
            <h2>
              {"Outcess Solutions"}
              <span>
                {/* <Moment fromNow>{timestamp?.toDate()}</Moment> */}
              </span>
            </h2>
            <p>{"Outcess is an integrated customer engagement and business process outsourcing company. We deliver innovative digital solutions that empower and optimize the performance of people, teams and organizations."}</p>
          </div>
        </div>
        <div className="post_body">
          <p>{"Outcess is an integrated customer engagement and business process outsourcing company. We deliver innovative digital solutions that empower and optimize the performance of people, teams and organizations."}</p>
          <img src={profile} alt="Alter_image" />

        </div>
        <div className="post_buttons">
          <InputOption Icon={ThumbUpIcon} title="Like" color="gray" OpenModal={undefined} />
          <InputOption Icon={CommentIcon} title="Comment" color="gray" OpenModal={undefined} />
          <InputOption Icon={ShareIcon} title="Share" color="gray" OpenModal={undefined} />
          <InputOption Icon={SendIcon} title="Send" color="gray" OpenModal={undefined} />
        </div>
      </div>
      {/* <div className="post">
        <div className="post_header">
          <Avatar src={profile}></Avatar>
          <div className="post_info">
            <h2>
              {"Kingsley Young"}
              <span> 
              </span>
            </h2>
            <p>{"It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."}</p>
          </div>
        </div>
        <div className="post_body">
          <p>{"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.  "}</p>
          <img src={profile} alt="Alter_image" />

        </div>
        <div className="post_buttons">
          <InputOption Icon={ThumbUpIcon} title="Like" color="gray" OpenModal={undefined} />
          <InputOption Icon={CommentIcon} title="Comment" color="gray" OpenModal={undefined} />
          <InputOption Icon={ShareIcon} title="Share" color="gray" OpenModal={undefined} />
          <InputOption Icon={SendIcon} title="Send" color="gray" OpenModal={undefined} />
        </div>
      </div> */}

    </div>
  );
};

export default Post;
